module.exports = __webpack_public_path__ + "static/media/verified-badge.39b41ab1.svg";